export function computeClassNames(
  staticClassNames: string,
  forwardedClassNames: string | undefined
) {
  return (
    staticClassNames + (forwardedClassNames ? ` ${forwardedClassNames}` : '')
  );
}
